module.exports = __webpack_public_path__ + "static/bg-dark4-13992cf83b5e7e9bd15baab640f4c182.jpg";